// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__2NMLw","selects":"Documents_selects__2hpqX"};